import { render, staticRenderFns } from "./DB_Internals.vue?vue&type=template&id=5b4985b2&scoped=true&"
import script from "./DB_Internals.vue?vue&type=script&lang=ts&"
export * from "./DB_Internals.vue?vue&type=script&lang=ts&"
import style0 from "./DB_Internals.vue?vue&type=style&index=0&id=5b4985b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4985b2",
  null
  
)

export default component.exports